import { memo } from "react";
import classNames from "classnames";
import { DisplayType } from "./SPMap";
import { useTranslation } from "react-i18next";

interface Props {
  onButtonClick: (displayType: DisplayType) => void;
  activeDisplayType: DisplayType;
}

const MapButtons = (props: Props) => {
  const { t } = useTranslation();
  const { onButtonClick, activeDisplayType } = props;
  return (
    <div className="scha__sales-partner__gmaps-sp-type-buttons">
      <button
        className={classNames(
          "scha__sales-partner__gmaps-sp-type-buttons__button",
          activeDisplayType === DisplayType.Schaeffler && "activeType"
        )}
        onClick={() => onButtonClick(DisplayType.Schaeffler)}
      >
        {t("salesPartner.gmap.customButton.schaeff")}
      </button>
      <button
        className={classNames(
          "scha__sales-partner__gmaps-sp-type-buttons__button",
          activeDisplayType === DisplayType.Map && "activeType"
        )}
        onClick={() => onButtonClick(DisplayType.Map)}
      >
        {t("salesPartner.gmap.customButton.map")}
      </button>
      <button
        className={classNames(
          "scha__sales-partner__gmaps-sp-type-buttons__button",
          activeDisplayType === DisplayType.Satellite && "activeType"
        )}
        onClick={() => onButtonClick(DisplayType.Satellite)}
      >
        {t("salesPartner.gmap.customButton.satelite")}
      </button>
    </div>
  );
};

export default memo(MapButtons);
